// Liefert verkleinerte Bild-URLs für Grid und Übersichten:
// Objektspeicher-Bilder werden serverseitig skaliert (?w=),
// lokale Bilder nutzen vorgerenderte Versionen aus /images/grid/.
export const thumbUrl = (src, w = 900) => {
  if (!src) return src;
  if (src.startsWith("/api/files/")) return `${src}?w=${w}`;
  if (src.startsWith("/images/")) return src.replace("/images/", "/images/grid/");
  return src;
};

// Alt-Text: eigenes Feld (DE/EN) hat Vorrang; Fallback „Projektname, Ort,
// Fotografie von Wim Jansen Delgado" in der Sprache der Seite
export const altFor = (work, lang = "de", ctx = {}) => {
  const custom = lang === "en" ? work.alt_en : work.alt_de;
  if (custom && custom.trim()) return custom.trim();
  const parts = [ctx.name, ctx.ort].filter(Boolean).join(", ");
  const basis = parts || (work.project ? work.project.split(":").pop().trim() : work.title);
  return lang === "en"
    ? `${basis}, photography by Wim Jansen Delgado`
    : `${basis}, Fotografie von Wim Jansen Delgado`;
};

// Große Kacheln (Startseite): mindestens 1400 px Breite ausliefern.
// Lokale Bilder liegen bereits mit 1429–1600 px vor, Objektspeicher wird skaliert.
export const wideUrl = (src, w = 1400) =>
  src?.startsWith("/api/files/") ? `${src}?w=${w}` : src;

// Responsive srcset für Objektspeicher-Bilder (serverseitige Skalierung per ?w=)
export const srcSet = (src, widths = [800, 1400, 2000]) =>
  src?.startsWith("/api/files/") ? widths.map((w) => `${src}?w=${w} ${w}w`).join(", ") : undefined;
